import { render } from "./IconSelection.vue?vue&type=template&id=724009c8&scoped=true"
import script from "./IconSelection.vue?vue&type=script&lang=js"
export * from "./IconSelection.vue?vue&type=script&lang=js"

import "./IconSelection.vue?vue&type=style&index=0&id=724009c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724009c8"]])

export default __exports__